import './style.css';

import React from 'react';

import { inject, observer } from 'mobx-react';

import type TIconIds from '../../common/type/icon-ids';
import type IconsLoadedStore from '../stores/loaded';
import LoadHelper from './controls/load-helper';

export interface IProps {
  className?: string;
  height?: string | number;
  strokeWidth?: string | number;
  value: TIconIds;
  width?: string | number;

  iconsLoadedStore?: IconsLoadedStore;
}

@inject('iconsLoadedStore')
@observer
class Icon extends React.Component<IProps> {
  static readonly defaultProps: Partial<IProps> = {
    className: '',
    height: 24,
    width: 24
  };

  render() {
    const { value, width, height, strokeWidth, className, iconsLoadedStore } = this.props;

    return (
      <>
        <svg
          className={`icon-default ${className}`}
          width={width}
          height={height}
          strokeWidth={strokeWidth}
        >
          <use width={width} height={height} xlinkHref={`#${value}`} />
        </svg>
        <LoadHelper id={value} load={iconsLoadedStore!.load} />
      </>
    );
  }
}

export default Icon;
